import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { pageVariants, EASE, DURATION } from "./tokens";

// Restrained route-level transition. Current page fades up, incoming page
// reveals from slightly lower with a whisper of scale.
export function PageTransition({ routeKey, className, children }) {
  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.div
        key={routeKey}
        variants={pageVariants}
        initial="initial"
        animate="enter"
        exit="exit"
        transition={{ duration: DURATION.normal, ease: EASE.enter }}
        className={className}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
}
